import { palette } from 'pkg/config/styles';

import { cssClasses, cssVarList, type CSSVariables } from 'pkg/css/utils';
import Link from 'pkg/router/Link';

import * as css from './styles.css';

interface BaseProps extends React.HTMLAttributes<
	HTMLDivElement | HTMLAnchorElement
> {
	noBorder?: boolean;
	hasShadow?: boolean;
	clickable?: boolean;
	href?: string;
	dark?: boolean;
	selected?: boolean;
}

export function Base({
	children,
	clickable,
	noBorder,
	hasShadow = true,
	dark,
	className,
	href,
	selected = false,
	...rest
}: BaseProps) {
	const vars: CSSVariables = {
		['bg-color']: palette.white,
		['border-color']: palette.gray[250],
	};

	if (selected) {
		vars['bg-color'] = palette.blue[200];
		vars['border-color'] = palette.blue[500];
	}

	const { style, ...restProps } = rest;
	const mergedStyle = { ...cssVarList(vars), ...style };

	if (href) {
		return (
			<Link
				href={href}
				className={cssClasses(
					css.base,
					noBorder && css.noBorder,
					!hasShadow && css.noShadow,
					clickable && css.clickable,
					dark && css.dark,
					className
				)}
				style={mergedStyle}
				{...restProps}>
				{children}
			</Link>
		);
	}

	return (
		<div
			className={cssClasses(
				css.base,
				noBorder && css.noBorder,
				!hasShadow && css.noShadow,
				clickable && css.clickable,
				dark && css.dark,
				className
			)}
			style={mergedStyle}
			{...restProps}>
			{children}
		</div>
	);
}
